/**
 * usePreviewMode
 *
 * /api/preview/status を一度だけ取得して返す軽量フック。
 * AuthContext と同じく root レベルで 1 回 fetch されるよう、
 * 結果は in-memory cache。
 */
import { useEffect, useState } from 'react';

let _cached = null;
let _inflight = null;

async function fetchStatus() {
  if (_cached) return _cached;
  if (_inflight) return _inflight;
  _inflight = fetch('/api/preview/status', { credentials: 'include' })
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      _cached = data || { previewMode: false };
      return _cached;
    })
    .catch(() => {
      _cached = { previewMode: false };
      return _cached;
    })
    .finally(() => { _inflight = null; });
  return _inflight;
}

const usePreviewMode = () => {
  const [status, setStatus] = useState(_cached);
  const [loading, setLoading] = useState(!_cached);

  useEffect(() => {
    let mounted = true;
    fetchStatus().then((s) => {
      if (mounted) {
        setStatus(s);
        setLoading(false);
      }
    });
    return () => { mounted = false; };
  }, []);

  return {
    previewMode: status?.previewMode === true,
    cutoffAt: status?.cutoffAt || null,
    launchAt: status?.launchAt || null,
    loading,
  };
};

export default usePreviewMode;
